import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import Layout from './components/common/Layout';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminRoute from './components/auth/AdminRoute';
import { AuthProvider } from './hooks/useAuth';
import { ThemeProvider } from './hooks/useTheme';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Admin from './pages/Admin';
import AdminUserManagementPage from './pages/AdminUserManagement';
import AdminUserDetailPage from './pages/AdminUserDetail';
import AdminCampaignPackagesPage from './pages/AdminCampaignPackages';
import AdminAdDetailPage from './pages/AdminAdDetail';
import AdminAdsManagementPage from './pages/AdminAdsManagement';
import AdminGuide from './pages/AdminGuide';
import ZoningLawAdmin from './pages/admin/ZoningLawAdmin';
import AdminAdAnalytics from './pages/admin/AdminAdAnalytics';
import Account from './pages/Account';
import Payment from './pages/Payment';
import PaymentConfirmation from './pages/PaymentConfirmation';
import MyCampaigns from './pages/MyCampaigns';
import CampaignPerformance from './pages/CampaignPerformance';
import Share from './pages/Share';
import Billboard from './pages/Billboard';
import StartCampaign from './pages/StartCampaign';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import AIVideoGenerator from './pages/AIVideoGenerator';
import AICreativeStudio from './pages/AICreativeStudio';

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <Header />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/account"
              element={
                <ProtectedRoute>
                  <Account />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <Admin />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/user-management"
              element={
                <AdminRoute>
                  <AdminUserManagementPage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/users/:id"
              element={
                <AdminRoute>
                  <AdminUserDetailPage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/ads/:id"
              element={
                <AdminRoute>
                  <AdminAdDetailPage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/ads"
              element={
                <AdminRoute>
                  <AdminAdsManagementPage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/campaign-packages"
              element={
                <AdminRoute>
                  <AdminCampaignPackagesPage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/guide"
              element={
                <AdminRoute>
                  <AdminGuide />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/zoning"
              element={
                <AdminRoute>
                  <ZoningLawAdmin />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/analytics"
              element={
                <AdminRoute>
                  <AdminAdAnalytics />
                </AdminRoute>
              }
            />
            <Route
              path="/payment"
              element={
                <ProtectedRoute>
                  <Payment />
                </ProtectedRoute>
              }
            />
            <Route
              path="/campaigns"
              element={
                <ProtectedRoute>
                  <MyCampaigns />
                </ProtectedRoute>
              }
            />
            <Route
              path="/campaigns/:id/performance"
              element={
                <ProtectedRoute>
                  <CampaignPerformance />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payment/confirmation"
              element={
                <ProtectedRoute>
                  <PaymentConfirmation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/campaign/start"
              element={
                <ProtectedRoute>
                  <StartCampaign />
                </ProtectedRoute>
              }
            />
            <Route
              path="/share"
              element={
                <ProtectedRoute>
                  <Share />
                </ProtectedRoute>
              }
            />
            <Route path="/billboard" element={<Billboard />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route
              path="/ai-video"
              element={
                <ProtectedRoute>
                  <AIVideoGenerator />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ai-creative-studio"
              element={
                <ProtectedRoute>
                  <AICreativeStudio />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Layout>
        <Footer />
      </Router>
    </AuthProvider>
  </ThemeProvider>
  );
};

export default App;
